import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

const dateTimeFormats = {
	'default': {
		day: {
			day: '2-digit'
		},
		week: {
			year: 'numeric', month: 'short', day: '2-digit', weekday: 'short',
		},
		short: {
			year: 'numeric', month: 'short', day: 'numeric'
		},
		long: {
			year: 'numeric', month: 'short', day: 'numeric',
			weekday: 'short', hour: 'numeric', minute: 'numeric'
		}
	},
	'ja': {
		day: {
			day: '2-digit'
		},
		week: {
			year: 'numeric', month: 'short', day: '2-digit', weekday: 'short',
		},
		short: {
			year: 'numeric', month: 'short', day: 'numeric',
		},
		long: {
			year: 'numeric', month: 'short', day: 'numeric',
			weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: true
		}
	}
};

// Create VueI18n instance with options
export default new VueI18n({
	locale: 'default',
	fallbackLocale: 'default',
	silentFallbackWarn: true,
	messages: window.events_data.translation.dictionary,
	dateTimeFormats,
});
